var map = {
	"./drug1.webp": 9978,
	"./drug10.webp": 7232,
	"./drug11.webp": 905,
	"./drug12.webp": 1876,
	"./drug13.webp": 2463,
	"./drug14.webp": 3917,
	"./drug15.webp": 1649,
	"./drug16.webp": 2540,
	"./drug17.webp": 4719,
	"./drug18.webp": 3351,
	"./drug19.webp": 2052,
	"./drug2.webp": 9721,
	"./drug20.webp": 5957,
	"./drug21.webp": 4365,
	"./drug22.webp": 2380,
	"./drug23.webp": 9213,
	"./drug24.webp": 4302,
	"./drug25.webp": 3160,
	"./drug26.webp": 1990,
	"./drug27.webp": 6402,
	"./drug3.webp": 5401,
	"./drug4.webp": 3633,
	"./drug5.webp": 4660,
	"./drug6.webp": 3202,
	"./drug7.webp": 6585,
	"./drug8.webp": 2765,
	"./drug9.webp": 6622
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1332;